import {
    faAngleUp,
    faCaretDown,
    faCheck,
    faChevronDown,
    faChevronRight,
    faCircle,
    faCircleSmall,
    faCircleStar,
    faCircleUser,
    faEllipsisVertical,
    faImages,
    faLockKeyhole,
    faLockKeyholeOpen,
    faShoppingBasket,
    faText,
    faUser,
    faUserSecret,
    faSpellCheck,
    type IconDefinition,
    faExclamationTriangle,
} from "@fortawesome/pro-solid-svg-icons";

export const solidIcons: IconDefinition[] = [
    faCaretDown,
    faCircle,
    faCheck,
    faChevronDown,
    faChevronRight,
    faText,
    faUser,
    faUserSecret,
    faShoppingBasket,
    faImages,
    faEllipsisVertical,
    faAngleUp,
    faLockKeyhole,
    faLockKeyholeOpen,
    faCircleStar,
    faCircleSmall,
    faCircleUser,
    faExclamationTriangle,
    faSpellCheck,
];
